import * as React from 'react';
import {
  Box,
  ListItem,
  List,
  ListItemText,
  Divider,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import PricingStepSummary from '../../Quote/parts/pricing-step-3';
import StandardTermsStep from '../../Quote/parts/standardterms';
interface ProjectQuoteDetailsProps {
  details: any;
  companyDetails: any;
  projectTemplateForm: any;
}
const ProjectQuoteDetails: React.FC<ProjectQuoteDetailsProps> = ({
  details,
  companyDetails,
  projectTemplateForm,
}) => {
  return (
    <Box sx={{ width: '100%', padding: '20px' }} className="mt-4">
      <Box
        sx={{
          padding: ' 16px',
        }}
      >
        {details && (
          <Box>
            <Typography component={'h3'} className="projectItemMainTitle">
              Quote Details
            </Typography>
            <Grid container spacing={2}>
              <Grid size={4}>
                <h3 className="projectItemSubTitle">Quote Status</h3>
                {details.quoteStatus.name}
              </Grid>
              {/* <Grid size={4}>
                <h3 className="projectItemSubTitle">Action</h3>
                {details.quoteStatusId}
              </Grid> */}
            </Grid>
            <Divider sx={{ mt: 2, mb: 2 }} />
            <Typography className="projectItemMainTitle">
              Customer Details
            </Typography>
            <Grid container spacing={2}>
              <Grid size={3}>
                <h3 className="projectItemSubTitle">Customer</h3>
                {details.customerName}
              </Grid>
              <Grid size={3}>
                <h3 className="projectItemSubTitle">Customer Email</h3>
                {details.customerEmail}
              </Grid>
              <Grid size={3}>
                <h3 className="projectItemSubTitle">Main Contact</h3>
                {details.customerMainContact}
              </Grid>
              <Grid size={3}>
                <h3 className="projectItemSubTitle">Main Contact Number</h3>
                {details.customerContactNumber}
              </Grid>
            </Grid>
            <Divider sx={{ mt: 2, mb: 2 }} />
            <Typography className="projectItemMainTitle">
              Project Details
            </Typography>
            <Grid container spacing={2}>
              <Grid size={3}>
                <h3 className="projectItemSubTitle">Project Name</h3>
                {details.projectName}
              </Grid>
              <Grid size={3}>
                <h3 className="projectItemSubTitle">Site Address</h3>
                {details.projectSiteAddress}
              </Grid>
              <Grid size={3}>
                <h3 className="projectItemSubTitle">Category of work</h3>
                {details.projectWorkCategory}
              </Grid>
              <Grid size={3}>
                <h3 className="projectItemSubTitle">Project Template</h3>
                {details.projectTemplate && (
                  <span>{details.projectTemplate.name}</span>
                )}
              </Grid>
              <Grid size={3}>
                <h3 className="projectItemSubTitle">Estimated Start Date</h3>
                {details.estimateStartDate}
              </Grid>
              <Grid size={3}>
                <h3 className="projectItemSubTitle">
                  Quote Submission Due Date
                </h3>
                {details.submissionDueDate}
              </Grid>
              <Grid size={3}>
                <h3 className="projectItemSubTitle">Induction Required</h3>
                {details.quoteInductions.map((inductions: any) => {
                  return inductions.name;
                })}
              </Grid>
            </Grid>

            <Divider sx={{ mt: 2, mb: 2 }} />
            {details && (
              <Box>
                {details.medias.length > 0 && (
                  <Typography className="projectItemMainTitle">
                    Document & Images
                  </Typography>
                )}
                {details.medias && (
                  <Grid container spacing={2}>
                    {details.medias.map((file: any, indexFile: number) => {
                      return (
                        <Grid
                          container
                          size={12}
                          key={`${file.name + '_' + indexFile}`}
                        >
                          <Box
                            sx={{
                              backgroundColor: 'rgba(0, 244, 255, 0.08)',
                              color: '#000',
                              margin: '5px',
                              padding: '20px',
                              width: '450px',
                            }}
                          >
                            <Box sx={{ borderBottom: '5px solid black' }}>
                              {file.name}
                            </Box>
                          </Box>
                        </Grid>
                      );
                    })}
                    <Divider sx={{ mt: 2, mb: 2 }} />
                  </Grid>
                )}
              </Box>
            )}

            <Typography className="projectItemMainTitle">Pricing</Typography>
            <Grid container size={12}>
              <PricingStepSummary
                billableFormItems={details ? details.billables : []}
                companyDetails={companyDetails}
                currentProject={{}}
                expandRowState={[]}
                handleArrow={() => {}}
                overheadPercentage={
                  details ? parseFloat(details.overheadsPercentage) : 0
                }
                handleOverHeadPercentage={() => {}}
                handleAutoCompleteChange={() => {}}
                handleBillableDetailChange={() => {}}
                handleBillableDialog={() => {}}
                handleResourceDialog={() => {}}
                projectForm={projectTemplateForm}
                projectTemplateList={[]}
                removeDetailsItem={() => {}}
                removeItem={() => {}}
                viewOnly={true}
                projectMargin={0}
                overheads={details ? parseFloat(details.overheads) : 0}
                handleOverHeads={() => {}}
                projectPercentage={
                  details ? details.projectMarginPercentage : 0
                }
                contigencyPercentage={
                  details ? details.contigenciesPercentage : 0
                }
                handleProjectPercentage={() => {}}
                handleProjectMargin={() => {}}
                handleContigencyPercentage={() => {}}
                handleAttached={() => {}}
                handleOpen={() => {}}
                handleBillableChange={() => {}}
                handleBillableBlur={() => {}}
                GST={details ? details.quoteGSTPrice : 0}
                GSTPrice={details ? details.quoteGSTPrice : 0}
              />
            </Grid>
            <Divider sx={{ mt: 2, mb: 2 }} />
            <Typography className="projectItemMainTitle">
              Terms & Conditions
            </Typography>
            <Grid size={12} container>
              <Grid container spacing={2}>
                <Grid size={12}>
                  <h6 className="projectItemMainTitle">
                    {'Standard Terms & Condition'}
                  </h6>
                  <StandardTermsStep
                    terms={details.standardTerms}
                    currentStandardTermsList={[]}
                  />
                </Grid>
                {details && (
                  <Grid size={12}>
                    <h6 className="projectItemMainTitle">
                      {'Adhoc Terms & Condition'}
                    </h6>
                    {details.adhocTerms && (
                      <List>
                        {details.adhocTerms.map((item: any, index: number) => {
                          return (
                            <ListItem
                              sx={{
                                display: 'list-item',
                                listStyle: 'disc',
                              }}
                              key={'terms_list_' + index}
                            >
                              <ListItemText>{item.termText}</ListItemText>
                            </ListItem>
                          );
                        })}
                      </List>
                    )}
                  </Grid>
                )}
                {details && (
                  <Grid container size={12}>
                    <h6 className="projectItemMainTitle">
                      {'Billable Exclusion'}
                    </h6>
                    {details.billables && (
                      <List>
                        {details.billables.map((item: any, index: number) => {
                          return item.exclusion ? (
                            <ListItem
                              sx={{
                                display: 'list-item',
                              }}
                              key={'billable_exclusion_name_list_' + index}
                            >
                              <List>
                                <ListItem
                                  sx={{
                                    display: 'inline-flex',
                                  }}
                                  key={'billable_exclusion_list_' + index}
                                >
                                  <ListItemText sx={{ fontWeight: 'bold' }}>
                                    {item.exclusion}
                                  </ListItemText>
                                </ListItem>
                              </List>
                            </ListItem>
                          ) : (
                            <span></span>
                          );
                        })}
                      </List>
                    )}
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default ProjectQuoteDetails;
